import * as swcHelpers from '@swc/helpers';
import { getStoreAddress } from '@grandvisionhq/analytics';
import { DateUtils } from '@grandvisionhq/utils';

const getExtraDataEvent = (data)=>{
    const { appointment , store  } = data !== null && data !== void 0 ? data : {};
    var _id, ref, _town, ref1, ref2;
    return swcHelpers.objectSpread({
        appointment: {
            type_of_appointment: appointment ? getTypeOfAppointment(appointment) : '',
            type_of_service: (_id = appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType.id) !== null && _id !== void 0 ? _id : '',
            age_range: appointment ? getAgeRangeLabel(appointment.appointmentType.ageGroup) : ''
        },
        store: {
            id: store ? String(store.code) : '',
            name: (ref = store === null || store === void 0 ? void 0 : store.name) !== null && ref !== void 0 ? ref : '',
            address: store ? getStoreAddress(swcHelpers.objectSpread({}, store, {
                city: (_town = store.town) !== null && _town !== void 0 ? _town : ''
            })) : '',
            postalCode: (ref1 = store === null || store === void 0 ? void 0 : store.postalCode) !== null && ref1 !== void 0 ? ref1 : '',
            city: (ref2 = store === null || store === void 0 ? void 0 : store.town) !== null && ref2 !== void 0 ? ref2 : ''
        },
        time: {
            startTime: (appointment === null || appointment === void 0 ? void 0 : appointment.startTime) ? DateUtils.toLocalDateTimeTimeZone(appointment.startTime) : '',
            endTime: (appointment === null || appointment === void 0 ? void 0 : appointment.endTime) ? DateUtils.toLocalDateTimeTimeZone(appointment.endTime) : ''
        }
    }, (appointment === null || appointment === void 0 ? void 0 : appointment.id) ? {
        appointmentId: {
            id: appointment.id
        }
    } : {});
};
const getTypeOfAppointment = (appointment)=>appointment.appointmentType.isVirtualAppointment ? 'videocall' : 'onsite'
;
const getStoreDetails = (storeDetails)=>{
    const { city , country , id , name , postalCode  } = storeDetails;
    return {
        city,
        country,
        id,
        name,
        postalCode,
        address: getStoreAddress(storeDetails)
    };
};
const getStoreDetailsWithoutCountry = (storeDetails)=>{
    const { city , id , name , postalCode  } = storeDetails;
    return {
        city,
        id,
        name,
        postalCode,
        address: getStoreAddress(storeDetails)
    };
};
const getAgeRangeLabel = (ageGroup)=>{
    if (ageGroup === 'CHILD') {
        return 'child appointment';
    }
    if (ageGroup === 'ADULT') {
        return 'adult';
    }
    if (ageGroup === 'SENIOR') {
        return 'senior';
    }
    return '';
};
const getStoreDetailsWithStock = (storeDetails)=>{
    const { town: city , country , code , name , postalCode , additionalStreetInfo , streetName , streetNumber ,  } = storeDetails;
    const storeAddressProperties = {
        city,
        additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : '',
        streetName,
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : ''
    };
    return {
        city: city.toLowerCase(),
        country,
        id: code.toString().toLowerCase(),
        name: name.toLowerCase(),
        postalCode,
        address: getStoreAddress(storeAddressProperties).toLowerCase(),
        stock: ''
    };
};

export { getAgeRangeLabel, getExtraDataEvent, getStoreDetails, getStoreDetailsWithStock, getStoreDetailsWithoutCountry };
//# sourceMappingURL=utils.js.map
